// React
import { ReactElement } from 'react';
// Next
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
// Modules
import isEmpty from 'lodash.isempty';
// Design system
import { SelectPopin } from '@utmb/design-system/select-popin/SelectPopin';
// Interfaces
import { IconsEnum } from '@utmb/types/icons';

interface Props {
    className?: string;
    /** Rendered in the mobile menu (adds a chevron to the trigger). */
    isMobile?: boolean;
    languages: string[];
    translationSlugs?: {
        [key: string]: string;
    };
}

export const LanguageSelector = (props: Props): ReactElement | null => {
    const { languages, className, isMobile } = props;

    const { locales, asPath, locale, push } = useRouter();
    const { t } = useTranslation();

    if (!locale || !locales || isEmpty(locales) || languages?.length <= 1) return null;

    return (
        <SelectPopin
            className={className}
            icon={IconsEnum.GLOBE}
            withChevron={isMobile}
            triggerLabel={locale.toUpperCase()}
            ariaLabel={`${t('common.selectLanguage')} : ${t(`common.languages.${locale}`)}`}
            title={t('common.selectLanguage')}
            options={locales
                .filter((lang: string) => languages?.includes(lang))
                .map((lang: string) => ({ value: lang, label: t(`common.languages.${lang}`), lang }))}
            value={locale}
            onSelect={(lang: string) => push(asPath, asPath, { locale: lang })}
        />
    );
};
